/* eslint-disable react/sort-comp */
/* eslint-disable import/prefer-default-export */
import React, { Component } from "react";
import {
	ModalBody,
	ModalFooter,
	ModalHeader,
	FormGroup,
	ComposedModal,
	Button,
	DataTable,
	Table,
	TableHeader,
	TableHead,
	TableRow,
	TableContainer,
	TableBody,
	TableCell,
	TableToolbar,
	TableToolbarContent,
	Accordion,
	AccordionItem,
	FormLabel,
	DropdownSkeleton,
	ComboBox,
	Loading,
	DataTableSkeleton,
	TextInput,
} from "carbon-components-react";
import moment from "moment";
import Add16 from "@carbon/icons-react/lib/add/16";
import Save16 from "@carbon/icons-react/lib/save/16";
import Delete16 from "@carbon/icons-react/lib/delete/16";
import Close16 from "@carbon/icons-react/lib/close/16";
import { NoRecordsPlaceholder } from "../../../helpers/jsonschemaform/DataTableExtention";
import { api } from "../../../helpers/api/api";
import { getError, entitiesLabels, apioperation, NotificationModule } from "../../../helpers/Constants";
import { showNotification } from "../../../helpers/notification/BaseNotification";
import InspectionRepository from "../../../helpers/api/InspectionRepository";
import { FindGHRSEmployer } from "../../common/FindGHRSEmployer";
import { AppContext } from "../../../helpers/context/AppContext";
import { v4 as uuid } from 'uuid';

const Entity = {
	inspected: "Inspected",
	inspector: "Inspector"
}


export class InspectionPersonnel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			disabledSavePersonnel: true,
			lisInspectors: [],
			isSubmitted: false,
			loadInspectionInspector: true,
			inspectorModel: {},
			newSaipemUser: null,

			// inspectors: [],
			inspectors: this.props.inspectionInfo.inspectors ?? [],
			inspectionInspectors: [],
			insepctorUser: [],

			//CR 161
			inspectedInspectorModal: {
				show: false,
				entity: null
			},
			isOpenManualInput: false,
			inspectedNoSaipem: this.props.inspectionInfo.inspectedNoSaipem ? this.props.inspectionInfo.inspectedNoSaipem.map((el) => ({ ...el, id: uuid() })) : [],
			inspectorsNoSaipem: this.props.inspectionInfo.inspectorsNoSaipem ? this.props.inspectionInfo.inspectorsNoSaipem.map((el) => ({ ...el, id: uuid() })) : [],
			inspectorsGHRS: this.props.inspectionInfo.inspectorsGHRS ?? [],
			inspectedsSaipem: this.props.inspectionInfo.inspectedsSaipem ? this.props.inspectionInfo.inspectedsSaipem.map(el =>({...el, fullname: `${el.name} ${el.surname}`, role: "Inspected" })) : [],
			noSaipemModel: null,
			//

			// INSPECTED
			employees: [],
			inspectedselect: null,
			loadInspectionInspected: true,
			inspectedModel: {},
			inspectedNew: null,
			isLoadingInspectors: false,
			isLoadingInspected: false,
			inspecteds: this.props.inspectionInfo.inspecteds ?? [],
			inspectionInspecteds: [],
			inspectorselect: null,
			modalInspectedsDeleteVisible: false,
			modalInspectorsDeleteVisible: false,
			modalNewInspectedsVisible: false,
			isOpenModalGHRS: false,
		};

		this.showUserModalInspector = this.showUserModal.bind(this);
		// this.addInspector = this.addInspector.bind(this);
		this.getInspectors = this.getInspectors.bind(this);
		this.getInspectorsInspection = this.getInspectorsInspection.bind(this);
		this.savePersonnel = this.savePersonnel.bind(this);
		this.deleteInspector = this.deleteInspector.bind(this);
		this.deleteInspecteds = this.deleteInspecteds.bind(this);
		//
		this.getInspectedsInspection = this.getInspectedsInspection.bind(this);
		this.getEmployees = this.getEmployees.bind(this);
		this.handleChangeGHRSModal = this.handleChangeGHRSModal.bind(this);
		this.setEmployer = this.setEmployer.bind(this);
		this.renderLoadingModal = this.renderLoadingModal.bind(this);
	}

	componentDidMount() {
		this.closeAccordion();
		this.getInspectorsWS();
	}

	renderLoadingModal = () => {
		const show = this.state.isSubmitted;
		return show && <Loading active withOverlay description="Saving..." />;
	};

	setSaipemUser = () => {
		const isForInspected = this.state.inspectedInspectorModal.entity === Entity.inspected
		if (isForInspected)  this.addinspectedsSaipem()
		else this.addInspectorSaipem()
	}

	addInspectorSaipem = () => {
		try {
			if (this.state.newSaipemUser == null) return;
			const inspectorS = this.state.newSaipemUser;
			const exists = this.state.inspectors.some((v) => v.email === inspectorS.email) || this.state.inspectorsNoSaipem.some((v) => v.email === inspectorS.email)
			if (!exists) {
				inspectorS.role = "Inspectors";
				this.setState({ inspectors: this.state.inspectors.concat(inspectorS) }, this.showUserModal);
			} else {
				showNotification.error(`${entitiesLabels.ERROR}`, "Inspector already on the list");
			}
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, 'addInspectorSaipem'));
		} 
		this.setState({newSaipemUser: null})
	};

	addinspectedsSaipem = () => {
		try {
			if (this.state.newSaipemUser == null) return;
			const inspectedS = this.state.newSaipemUser;
			const exists = this.state.inspecteds.some((v) => v.email === inspectedS.email) || this.state.inspectedNoSaipem.some((v) => v.email === inspectedS.email) || this.state.inspectedsSaipem.some((v) => v.email === inspectedS.email)			
			if (!exists) {
				inspectedS.role = "Inspected";
				inspectedS.fullname = `${inspectedS.name} ${inspectedS.surname}` ;
				this.setState({ inspectedsSaipem: this.state.inspectedsSaipem.concat(inspectedS) }, this.showUserModal);
			} else {
				showNotification.error(`${entitiesLabels.ERROR}`, "Inspected already on the list");
			}
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, 'addinspectedsSaipem'));
		}
		this.setState({newSaipemUser: null})
	};


	closeAccordion() {
		this.setState({
			isLoadingInspectors: false,
			isLoadingInspected: false,
		});
	}
	getInspectorsWS = () => {
		this.setState({
			isLoadingInspectors: true,
		});
		api.getAll(`/users/userworksite/${NotificationModule.ModuleInspection}`)
			.then((response) => {
				const { data } = response;
				this.setState({
					insepctorUser: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION_NOTIFICATION, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingInspectors: false,
				});
			});
	};
	getInspectorFiltered() {
		const data = (this.state.insepctorUser || []).filter((x) => x.worksite.includes(this.props.worksite));
		return data;
	}
	getInspectorsInspection() {
		this.setState({
			isLoadingInspectors: true,
		});
		const id = this.props.plan;

		if (this.state.loadInspectionInspector === false || id == null) return;

		api.getAll(`inspection/report/${id}/inspectors`)
			.then((response) => {
				this.setState({
					inspectors: response.data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingInspectors: false,
					loadInspectionInspector: false,
					disabledSavePersonnel: false,
				});
			});
	}

	getInspectedsInspection() {
		this.setState({
			isLoadingInspected: true,
		});
		const id = this.props.plan;
		if (this.state.loadInspectionInspected === false || id == null) return;

		api.getAll(`inspection/report/${id}/inspecteds`)
			.then((response) => {
				this.setState({
					inspecteds: response.data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingInspected: false,
					loadInspectionInspected: false,
					disabledSavePersonnel: false,
				});
			});
	}

	getUser = () => {
		if(this.state.isOpenUserModalInspector) {
			const idWorksite = this.props.worksite;
			this.getInspectors(idWorksite);
		}
	}

	
	getInspectorsFilteredByWs = () => {
		if(this.state.isOpenUserModalInspector){
			const idWorksite = this.props.worksite;
			this.getInspectors(idWorksite);
		}
	}

	showUserModal() {
		// this.setState((oldState) => ({ isOpenUserModalInspector: !oldState.isOpenUserModalInspector }), this.getUser);
		this.setState((oldState) => ({ isOpenUserModalInspector: !oldState.isOpenUserModalInspector }), this.getInspectorsFilteredByWs);
			

		if(!this.state.isOpenUserModalInspector) this.setState({inspectedInspectorModal:{ ...this.state.inspectedInspectorModal, show: false}})
	}

	// onChangeInspector = (inputName) => {
	// 	const inspectorS = inputName.selectedItem;
	// 	this.setState({
	// 		newSaipemUser: inspectorS,
	// 	});
	// };
	onChangeSaipemUser = (inputName) => this.setState({ newSaipemUser: inputName.selectedItem});
	

	savePersonnel = () => {
		this.setState({
			isSubmitted: true,
		});
		const { inspectors } = this.state;
		const { inspecteds } = this.state;
		//CR 161
		const { inspectorsNoSaipem } = this.state;
		const { inspectedNoSaipem } = this.state;
		const { inspectorsGHRS } = this.state;
		const { inspectedsSaipem } = this.state;

		const idInspection = this.props.plan;
		const datiForm = {
			idInspection,
			inspectors,
			inspecteds,
			//CR 161
			inspectorsNoSaipem,
			inspectedNoSaipem,
			inspectorsGHRS,
			inspectedsSaipem
		};
		api.put("/inspection/personnel", datiForm)
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, "Successfully sent");
				} else {
					showNotification.error(`${entitiesLabels.ERROR}`, getError("Unsuccessfully sent", entitiesLabels.INSPECTION, apioperation.POST));
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.POST));
			})
			.finally(() => {
				this.setState({
					loadInspectionInspector: true,
					newSaipemUser: null,
					isSubmitted: false,
				});
			});
	};

	deleteInspector = () => {
		const copy = {...this.state}
		const saipemInspector = this.state?.inspectors?.find(inspector => inspector.email === this.state.inspectorselect)
		const isGhrs = this.state?.inspectorsGHRS?.find(inspector => inspector.email === this.state.inspectorselect)
		if(saipemInspector) copy.inspectors = this.state?.inspectors?.filter((inspector) => inspector.email !== this.state.inspectorselect) ;
		else if (isGhrs) copy.inspectorsGHRS = this.state?.inspectorsGHRS?.filter((inspectorGHRS) => inspectorGHRS.email !== this.state.inspectorselect);
		else copy.inspectorsNoSaipem = this.state?.inspectorsNoSaipem?.filter((inspectorNS) => inspectorNS.email !== this.state.inspectorselect);
		copy.modalInspectorsDeleteVisible = false
		this.setState(copy);
	};

	deleteInspecteds = () => {
		const copy = {...this.state}
		const InspectedsGHRS = this.state?.inspecteds?.find(inspected => inspected.email === this.state.inspectedselect)
		const inspectedsSaipem = this.state?.inspectedsSaipem?.find(inspected => inspected.email === this.state.inspectedselect)
		if(InspectedsGHRS) copy.inspecteds = this.state?.inspecteds?.filter((inspected) => inspected.email !== this.state.inspectedselect) ;
		else if (inspectedsSaipem) copy.inspectedsSaipem = this.state?.inspectedsSaipem?.filter((inspected) => inspected.email !== this.state.inspectedselect) ;
		else copy.inspectedNoSaipem = this.state?.inspectedNoSaipem?.filter((inspectedNS) => inspectedNS.email !== this.state.inspectedselect);
		copy.modalInspectedsDeleteVisible = false
		this.setState(copy);
	};

	getInspectors = (idWorkSite) => {
		if (idWorkSite == null) return;
		this.setState({
			isLoadingInspectors: true,
		});

		api.get("inspection/inspectors/", idWorkSite)
			.then((response) => {
				this.setState({
					lisInspectors: response.data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingInspectors: false,
				});
			});
	};

	modalNewInspector() {
		const modalHeader = {
			title: this.state.isUpdateDocument ? "Edit Related Document" : `Add new ${this.state.inspectedInspectorModal.entity}`,
			iconDescription: "Close",
			buttonOnClick: () => this.showUserModal(),
		};
		const listInspectors = this.props.worksite ? this.getInspectorFiltered() : [];
		const selectedItemCombo = {
			inspectors: (this.state.lisInspectors || []).find((el) => el.id === this.state?.inspectionModel?.inspectors),
			inspectorsws: (listInspectors || []).find((el) => el.id === this.state?.inspectionModel?.inspectors[0]?.id),
			selectedUser: (listInspectors || []).find(user => user.id === this.state?.newSaipemUser?.id) || null
		};

		return (
			<>
				<ComposedModal className="light-modal" open={this.state.isOpenUserModalInspector} danger="false" onClose={() => false}>
					<ModalHeader {...modalHeader}>
						<p />
					</ModalHeader>
					<ModalBody className="margin-modal-custom">
						<div className="bx--grid--full-width">
							<div className="bx--row">
								<FormGroup legendText="" className="bx--col-md-8">
									<FormLabel className="some-class">{this.state.inspectedInspectorModal.entity}*</FormLabel>
									{this.state.isLoadingInspectors ? (
										<DropdownSkeleton />
									) : (
										<ComboBox
											id="inspectors"
											// placeholder={this.state.inspectionModel.inspector ? this.state.inspectionModel.inspector : selectedItemCombo.inspector == [] ? selectedItemCombo.inspector : 'Select'}
											name="inspectors"
											alt="inspectorModel"
											onChange={this.onChangeSaipemUser}
											itemToString={(item) => (item ? item.email : "")}
											// initialSelectedItem={selectedItemCombo.idInspector}
											initialSelectedItem={selectedItemCombo.selectedUser}
											items={listInspectors}
											//  disabled={this.state.inspectionModel.idWorkSite == null || this.state?.inspectors == null || this.state?.inspectors?.length <= 0}
											// invalid={validations.idInspector != null}
										/>
									)}
								</FormGroup>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button kind="secondary" onClick={() => this.showUserModal()}>
							Cancel
						</Button>
						<Button kind="primary" onClick={() => this.setSaipemUser()}>
							Save
						</Button>
					</ModalFooter>
				</ComposedModal>
			</>
		);
	}

	async getEmployees() {
		try {
			const employees = await InspectionRepository.getEmployees();
			this.setState({
				employees,
			});
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMPLOYER, apioperation.GET));
		}
	}

	renderDeleteInspectedsModal = () =>
		this.state.modalInspectedsDeleteVisible && (
			<div className="bx--modal bx--modal-tall is-visible">
				<div className="bx--modal-container">
					<div className="bx--modal-header">
						<h3 className="bx--modal-header__heading">Delete Team Member</h3>
						<Button className="bx--modal-close" renderIcon={Close16} onClick={this.handleDeleteInspectedsModal} />
					</div>

					<div className="bx--modal-content">
						<div className="bx--row bx--modal-content-detail">
							<div className="bx--col-lg-12 bx--col-md-12">
								<h5 className="align-center">Press confirm to remove Inspected from Team Members</h5>
							</div>
						</div>
					</div>
					<div className="bx--modal-footer">
						<Button className="button--max-width" kind="secondary" onClick={this.handleDeleteInspectedsModal}>
							Cancel
						</Button>
						<Button className="button--max-width" kind="primary" onClick={this.deleteInspecteds}>
							Confirm
						</Button>
					</div>
				</div>
			</div>
		);

	renderDeleteInspectorModal = () =>
		this.state.modalInspectorsDeleteVisible && (
			<div className="bx--modal bx--modal-tall is-visible">
				<div className="bx--modal-container">
					<div className="bx--modal-header">
						<h3 className="bx--modal-header__heading">Delete Team Member</h3>
						<Button className="bx--modal-close" renderIcon={Close16} onClick={() => this.closeModalDeleteInspector()} />
					</div>

					<div className="bx--modal-content">
						<div className="bx--row bx--modal-content-detail">
							<div className="bx--col-lg-12 bx--col-md-12">
								<h5 className="align-center">Press confirm to remove Inspected from Team Members</h5>
							</div>
						</div>
					</div>
					<div className="bx--modal-footer">
						<Button className="button--max-width" kind="secondary" onClick={() => this.closeModalDeleteInspector()}>
							Cancel
						</Button>
						<Button className="button--max-width" kind="primary" onClick={() => this.deleteInspector()}>
							Confirm
						</Button>
					</div>
				</div>
			</div>
		);

	handleDeleteInspectedsModal = (email) => {
		this.setState((oldState) => ({
			inspectedselect: email,
			modalInspectedsDeleteVisible: !oldState.modalInspectedsDeleteVisible,
		}));
	}

	handleDeleteInspectorModal(email) {
		this.setState({
			inspectorselect: email,
			modalInspectorsDeleteVisible: true,
		});
	}

	closeModalDeleteInspector() {
		this.setState({
			inspectorselect: null,
			modalInspectorsDeleteVisible: false,
		});
	}

	// setEmployer = (employer) => {
	// 	if (employer && employer.id) {
	// 		const oldInspectionDocument = this.state.inspecteds || [];

	// 		const exists = oldInspectionDocument.some((v) => v.ghrS_ID === employer.ghrS_ID) || this.state.inspectedNoSaipem.some(x => x.email === employer.email)
	// 		if (!exists) {
	// 			const newinspectioDocument = oldInspectionDocument.concat([employer]);
	// 			let statusCopy = { ...this.state.employermodel };
	// 			statusCopy = newinspectioDocument;
	// 			this.setState({ inspecteds: statusCopy });
	// 			this.setState({ isOpenModalGHRS: false });
	// 		} else {
	// 			showNotification.error(`${entitiesLabels.ERROR}`, "Inspected already on the list");
	// 		}
	// 	}
	// };

	setEmployer = (employer) => {
		if ( !(employer && employer.id) ) return

		const isForInspected = this.state.inspectedInspectorModal.entity === Entity.inspected
		if (isForInspected)  this.setInspectedEmployer(employer)
		else this.setInspectorEmployer(employer)
	};


	setInspectedEmployer = (employer) => {
		const oldInspectionDocument = this.state.inspecteds || [];
		const exists = oldInspectionDocument.some((v) => v.ghrS_ID === employer.ghrS_ID) || this.state.inspectedNoSaipem.some(x => x.email === employer.email)
		if (!exists) {
			const newinspectioDocument = oldInspectionDocument.concat([employer]);
			let statusCopy = { ...this.state.employermodel };
			statusCopy = newinspectioDocument;
			this.setState({ inspecteds: statusCopy });
			this.setState({ isOpenModalGHRS: false });
		} else {
			showNotification.error(`${entitiesLabels.ERROR}`, "Inspected already on the list");
		}
		this.setState({ employermodel: null });
	};

	setInspectorEmployer = (employer) => {
		const oldInspectionDocument = this.state.inspectorsGHRS || [];
		const exists = oldInspectionDocument.some((v) => v.ghrS_ID === employer.ghrS_ID) || this.state.inspectorsNoSaipem.some(x => x.email === employer.email) || this.state.inspectorsGHRS.some(x => x.email === employer.email)
		if (!exists) {
			const newinspectioDocument = oldInspectionDocument.concat([employer]);
			let statusCopy = { ...this.state.employermodel };
			statusCopy = newinspectioDocument;
			this.setState({ inspectorsGHRS: statusCopy });
			this.setState({ isOpenModalGHRS: false });
		} else {
			showNotification.error(`${entitiesLabels.ERROR}`, "Inspector already on the list");
		}
		this.setState({ employermodel: null });
	};
	


	addManualInspectorInspected = () => {
		try {
			if (this.state.noSaipemModel == null) return;
			const isInspected = this.state.inspectedInspectorModal.entity === Entity.inspected
			const newPerson = {...this.state.noSaipemModel};
			const referenceModel = isInspected ? [...this.state.inspectedNoSaipem, ...this.state.inspecteds] : [...this.state.inspectorsNoSaipem, ...this.state.inspectors] 
			const exists = referenceModel.some((v) => v.email === newPerson.email);
			if (!exists) {
				newPerson.id = uuid();
				newPerson.role = this.state.inspectedInspectorModal.entity;
				newPerson.IdInspection = this.props.inspectionInfo.id;
				newPerson.fullname = `${newPerson.name} ${newPerson.surname}`
				if(isInspected) {
					this.setState({
						inspectedNoSaipem: this.state.inspectedNoSaipem.concat(newPerson),
						isOpenManualInput: false,
						inspectedInspectorModal: {show: false, entity: null},
						noSaipemModel: null
					}) 
				}else{
					this.setState({
						inspectorsNoSaipem: this.state.inspectorsNoSaipem.concat(newPerson),
						isOpenManualInput: false,
						inspectedInspectorModal:  {show: false, entity: null},
						noSaipemModel: null
					})
				}
			} else {
				showNotification.error(`${entitiesLabels.ERROR}`, this.state.inspectedInspectorModal.entity + " already on the list");
			}
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INSPECTION, 'addManualInspectorInspected'));
		}
	};

	handleChangeGHRSModal() {
		this.setState({ isOpenModalGHRS: false });
	}

	openInspectedInspectorModal = (entityType) => {
		this.setState({ inspectedInspectorModal: {show: true, entity: entityType} });
	}

	handleManualInputChangeModel = (property, value) => {
		const copy = { ...this.state.noSaipemModel };
		copy[property] = value;
		this.setState({ noSaipemModel: copy});
	};


	renderModal = () => {
		// const onMainChoice = () => {
		// 	if (this.state.inspectedInspectorModal.entity === Entity.inspected) this.setState({inspectedInspectorModal:{show: false, entity: null}, isOpenModalGHRS: true })
		// 	else this.showUserModalInspector()
		// }
		const onSaipemChoice = () => {
			this.setState({ inspectedInspectorModal:  {...this.state.inspectedInspectorModal, show: false} })
			this.showUserModal()
		}
		const onGHRSChoice = () => this.setState({ inspectedInspectorModal:  {...this.state.inspectedInspectorModal, show: false}, isOpenModalGHRS: true })
		const onManualChoice = () => this.setState({isOpenManualInput: true, inspectedInspectorModal:  {...this.state.inspectedInspectorModal, show: false} })
		const onCloseModal = () => this.setState({ inspectedInspectorModal: {show: false, entity: null} })

		return (
			<ComposedModal
				className="light-modal"
				open={this.state.inspectedInspectorModal.show}
				danger="false"
				onClose={onCloseModal}>
				<ModalHeader className="margin-modal" onClick={onCloseModal}>
					<p>Add New {this.state.inspectedInspectorModal.entity}</p>
				</ModalHeader>
				<ModalBody className="margin-modal">
					<div className="bx--row two-button-center modal--elemnts-buttons">
						{/* <Button kind="primary" className="bx--col-md-6" onClick={onMainChoice}>
							{`${this.state.inspectedInspectorModal.entity === Entity.inspected ? "GHRS" : "Saipem"} research`}
						</Button> */}
						<Button kind="primary" className="bx--col-md-6" onClick={onSaipemChoice}>
							Saipem research
						</Button>
						<Button kind="primary" className="bx--col-md-6" onClick={onGHRSChoice}>
							GHRS research
						</Button>
						<Button kind="primary" className="bx--col-md-6" onClick={onManualChoice}>
							Manual input
						</Button>
					</div>
				</ModalBody>
					<ModalFooter>
						<Button kind="secondary" onClick={onCloseModal}>
							Cancel
						</Button>
				</ModalFooter>
			</ComposedModal>
		)
	}

	renderManualInputModal = () => {
		const onChange = (e) => {
			const value = e.target.value
			const property = e.target.name
			this.handleManualInputChangeModel(property, value)
		}

		const onCancel = () => {
			this.setState({isOpenManualInput: false, noSaipemModel: null})
		}

		return (
			<ComposedModal
				className="light-modal"
				open={this.state.isOpenManualInput}
				danger="false"
				onClose={onCancel}>
				<ModalHeader className="margin-modal" onClick={() => this.setState({ isOpenManualInput: false })}>
					<p>Add New {this.state.inspectedInspectorModal.entity}</p>
				</ModalHeader>
				<ModalBody className="margin-modal">
				<div className="bx--grid--full-width">
					<div className="bx--row">
						<FormGroup legendText="Name*" className="bx--col-md-4 bx--col-lg-6">
							<TextInput
								id="name"
								name="name"
								alt="modelNoSaipem"
								placeholder="Input Name"
								value={this.state.noSaipemModel?.name ?? ''}
								type="text"
								hideLabel={true}
								labelText=""
								onChange={onChange}
							/>
						</FormGroup>
						<FormGroup legendText="Surname*" className="bx--col-md-4 bx--col-lg-6">
							<TextInput
								id="txt-surname"
								name="surname"
								alt="modelNoSaipem"
								placeholder="Input Surname"
								value={this.state.noSaipemModel?.surname ?? ""}
								type="text"
								hideLabel={true}
								labelText=""
								onChange={onChange}
							/>
						</FormGroup>
						<FormGroup legendText="Company" className="bx--col-md-4 bx--col-lg-6">
							<TextInput
								id="txt-badgeNumber"
								name="company"
								alt="modelNoSaipem"
								placeholder="Input Company"
								value={this.state.noSaipemModel?.company ?? ""}
								type="text"
								hideLabel={true}
								labelText=""
								onChange={onChange}
							/>
						</FormGroup>
						<FormGroup legendText="Email* (Personal Email Addresses are not allowed)" className="bx--col-md-4 bx--col-lg-6">
							<TextInput
								id="txt-email"
								name="email"
								alt="modelNoSaipem"
								placeholder="Input Email"
								value={this.state.noSaipemModel?.email ?? ""}
								type="text"
								hideLabel={true}
								labelText=""
								onChange={onChange}
								title="&#9888; Do Not use Personal Accounts"
							/>
						</FormGroup>
					</div>
				</div>
				</ModalBody>
				<ModalFooter>
					<Button kind="secondary" onClick={onCancel}>
						Cancel
					</Button>
					<Button
						kind="primary"
						disabled={!(this.state.noSaipemModel?.name && this.state.noSaipemModel?.surname && this.validateEmail(this.state.noSaipemModel?.email)) }
						onClick={this.addManualInspectorInspected}>
						Confirm
					</Button>
				</ModalFooter>
			</ComposedModal>
		);
	}


	validateEmail = (email) => {
		if(!email) return false
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	}

    	renderInspecteds = () => {
		const headers = [
			{
				key: "fullname",
				header: "Name",
				isSortable: true,
			},
			{
				key: "email",
				header: "Email",
			},
			{
				key: "role",
				header: "Position",
			},
			{
				key: "company",
				header: "Company",
			},
		];
		return (
			<DataTable
				useZebraStyles
				// rows={this.state.inspecteds || []}
				rows={(this.state.inspecteds || []).concat(this.state.inspectedNoSaipem || []).concat(this.state.inspectedsSaipem)}
				headers={headers}
				render={({ rows, getHeaderProps }) => (
					<TableContainer>
						<TableToolbar>
							<TableToolbarContent className="table-toolbar-custom-content">
								<div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
									<h6>Other personnel involved in the inspection</h6>
								</div>
								{!this.props.editingDisabledCheck && (
									<div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
										<Button onClick={() => this.openInspectedInspectorModal(Entity.inspected)} kind="primary" renderIcon={Add16} disabled={this.props.disabled} iconDescription="">
											Add New Inspected
										</Button>
									</div>
								)}
							</TableToolbarContent>
						</TableToolbar>
						{this.renderDeleteInspectedsModal()}
						<Table>
							<TableHead>
								<TableRow>
									{headers.map((header) => (
										<TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
									))}
									<TableHeader className="align-center">Actions</TableHeader>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows == null || rows.length === 0 ? (
									<NoRecordsPlaceholder colSpan={headers.length + 2} />
								) : (
									rows.map((row) => (
										<TableRow key={`row_${row.id}`}>
											{row.cells.map((cell) => (
												<TableCell key={cell.id}>{cell.value}</TableCell>
											))}
											<TableCell key="action" className="tableActions align-center">
												{!this.props.editingDisabledCheck && (
													<div>
														<Button onClick={() => this.handleDeleteInspectedsModal(row.cells[1].value)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" disabled={this.props.disabled} />
													</div>
												)}
											</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			/>
		);
	};

	renderInspector = () => {
		const skeletonRowCount = 3;
		const headers = [
			{
				key: "name",
				header: "Name",
				isSortable: true,
			},
			{
				key: "email",
				header: "Email",
			},
			{
				key: "role",
				header: "Position",
			},
		];
		return this.state.inspectors !== 0 || !this.state.isLoadingInspectors ? (
			<DataTable
				useZebraStyles
				// rows={this.state.inspectors || []}
				rows={(this.state.inspectors || []).concat(this.state.inspectorsNoSaipem || []).concat(this.state.inspectorsGHRS)}
				headers={headers}
				render={({ rows, getHeaderProps }) => (
					<TableContainer>
						<TableToolbar>
							<TableToolbarContent className="table-toolbar-custom-content">
								<div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
									<h6>Inspection Team</h6>
								</div>
								{!this.props.editingDisabledCheck && (
									<div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
										<Button
											onClick={() =>this.openInspectedInspectorModal(Entity.inspector)}
											kind="primary"
											renderIcon={Add16}
											iconDescription="">
											Add New Inspector
										</Button>
									</div>
								)}
							</TableToolbarContent>
						</TableToolbar>
						{this.renderDeleteInspectorModal()}
						<Table>
							<TableHead>
								<TableRow>
									{headers.map((header) => (
										<TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
									))}
									<TableHeader className="align-center">Actions</TableHeader>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows == null || rows.length === 0 ? (
									<NoRecordsPlaceholder colSpan={headers.length + 2} />
								) : (
									rows.map((row) => (
										<TableRow key={`row_${row.id}`}>
											{row.cells.map((cell) => (
												<TableCell key={cell.id}>
													{cell.info.header.includes("date") ? moment(cell.value).format("DD/MM/YYYY") : cell.info.header.includes("workSite") ? cell.value?.name || "N/A" : cell.value}
												</TableCell>
											))}
											<TableCell key="action" className="tableActions align-center">
												{!this.props.editingDisabledCheck && (
													<div>
														{row?.cells[2].value !== "Team Leader" ? (
															<Button onClick={() => this.handleDeleteInspectorModal(row.cells[1].value)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" />
														) : (
															""
														)}
													</div>
												)}
											</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			/>
		) : (
			<DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
		);
	};

	render() {
		const validations = {
			name: null,
			surname: null,
			email: null,
			company: null,
		};
		return (
			<AppContext.Consumer>
				{() => (
					<>
						<div>
							{this.modalNewInspector()}
							{this.renderLoadingModal()}

							{/* CR 161 */}
							{this.renderManualInputModal()}
							{this.renderModal()}
							<FindGHRSEmployer isOpenModal={this.state.isOpenModalGHRS} onCancel={this.handleChangeGHRSModal} onOk={this.setEmployer} />
							{/* CR 161 */}

							<Accordion>
								<AccordionItem
									className="auditAccordionTitle"
									title="Inspection team"
									// onClick={() => this.getInspectorsInspection()}
									onHeadingClick={() => this.closeAccordion()}
									id={`AccordionInspectors${this.props.plan}`}
									key={`AccordionInspectors${this.props.plan}`}>
									<div className="bx--row">
										<div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12">{this.renderInspector()}</div>
									</div>
								</AccordionItem>
								<AccordionItem
									className="auditAccordionTitle"
									title="Other personnel involved in the inspection"
									// onClick={() => this.getInspectedsInspection()}
									onHeadingClick={() => this.closeAccordion()}
									id={`AccordionInspecteds${this.props.plan}`}
									key={`AccordionInspecteds${this.props.plan}`}>
									<div className="bx--row">
										<div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12">{this.renderInspecteds()}</div>
									</div>
								</AccordionItem>
							</Accordion>

							<div className="bx--row ">
								{!this.props.editingDisabledCheck && (
									<div className="bx--row table-toolbar-custon-content-info-end ">
										<Button size="default" renderIcon={Save16} kind="secondary" onClick={() => this.savePersonnel()} 
										// disabled={this.state.disabledSavePersonnel} 
										iconDescription="">
											Save
										</Button>
									</div>
								)}
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
